"use strict";
/* eslint-disable object-curly-newline */

Object.defineProperty(exports, "__esModule", {
  value: true
}); // https://www.justice.gov/ust/eo/bapcpa/20230401/bci_data/median_income_table.htm

function getStateMedianFamilyIncome(dirtyState, persons) {
  if (!dirtyState) throw new Error("Missing State");
  var state = dirtyState.toUpperCase();
  if (!persons || persons === 0 || Number.isNaN(persons)) throw new Error("Missing Persons Count");
  var medianMap = {
    AK: {
      "1": 82512,
      "2": 98650,
      "3": 114293,
      "4": 131159
    },
    AL: {
      "1": 59605,
      "2": 72419,
      "3": 86685,
      "4": 94373
    },
    AR: {
      "1": 54658,
      "2": 67179,
      "3": 77167,
      "4": 90146
    },
    AZ: {
      "1": 66340,
      "2": 83660,
      "3": 94526,
      "4": 107944
    },
    CA: {
      "1": 74819,
      "2": 96600,
      "3": 109458,
      "4": 128533
    },
    CO: {
      "1": 77331,
      "2": 101720,
      "3": 120195,
      "4": 135820
    },
    CT: {
      "1": 81285,
      "2": 101344,
      "3": 124441,
      "4": 149181
    },
    DC: {
      "1": 85933,
      "2": 141690,
      "3": 172958,
      "4": 181083
    },
    DE: {
      "1": 75674,
      "2": 92239,
      "3": 104443,
      "4": 128053
    },
    FL: {
      "1": 62973,
      "2": 77639,
      "3": 89908,
      "4": 104069
    },
    GA: {
      "1": 62468,
      "2": 79803,
      "3": 90959,
      "4": 112675
    },
    GU: {
      "1": 50975,
      "2": 60950,
      "3": 69455,
      "4": 84049
    },
    HI: {
      "1": 78745,
      "2": 94677,
      "3": 113594,
      "4": 133656
    },
    IA: {
      "1": 61283,
      "2": 83592,
      "3": 98987,
      "4": 120308
    },
    ID: {
      "1": 68781,
      "2": 78980,
      "3": 90806,
      "4": 106407
    },
    IL: {
      "1": 66950,
      "2": 86442,
      "3": 105897,
      "4": 125022
    },
    IN: {
      "1": 60351,
      "2": 77580,
      "3": 91431,
      "4": 105581
    },
    KS: {
      "1": 64518,
      "2": 82685,
      "3": 100333,
      "4": 111192
    },
    KY: {
      "1": 57509,
      "2": 69905,
      "3": 83622,
      "4": 102067
    },
    LA: {
      "1": 53821,
      "2": 66051,
      "3": 77910,
      "4": 97149
    },
    MA: {
      "1": 81170,
      "2": 103404,
      "3": 127323,
      "4": 161149
    },
    MD: {
      "1": 81293,
      "2": 104569,
      "3": 127386,
      "4": 151138
    },
    ME: {
      "1": 66369,
      "2": 79644,
      "3": 103965,
      "4": 114591
    },
    MI: {
      "1": 64579,
      "2": 77600,
      "3": 95775,
      "4": 114456
    },
    MN: {
      "1": 72319,
      "2": 93855,
      "3": 117426,
      "4": 141903
    },
    MO: {
      "1": 59605,
      "2": 76787,
      "3": 91333,
      "4": 105914
    },
    MP: {
      "1": 34231,
      "2": 34231,
      "3": 39826,
      "4": 58576
    },
    MS: {
      "1": 51554,
      "2": 62496,
      "3": 74909,
      "4": 84767
    },
    MT: {
      "1": 65242,
      "2": 80779,
      "3": 84585,
      "4": 111516
    },
    NC: {
      "1": 61811,
      "2": 78415,
      "3": 89965,
      "4": 109590
    },
    ND: {
      "1": 66813,
      "2": 89505,
      "3": 104222,
      "4": 122543
    },
    NE: {
      "1": 63813,
      "2": 83412,
      "3": 98600,
      "4": 121455
    },
    NH: {
      "1": 84017,
      "2": 99807,
      "3": 130391,
      "4": 153749
    },
    NJ: {
      "1": 83102,
      "2": 100763,
      "3": 130239,
      "4": 157404
    },
    NM: {
      "1": 56766,
      "2": 71277,
      "3": 77923,
      "4": 83592
    },
    NV: {
      "1": 64412,
      "2": 81020,
      "3": 88992,
      "4": 99819
    },
    NY: {
      "1": 69135,
      "2": 87550,
      "3": 105435,
      "4": 131389
    },
    OH: {
      "1": 61617,
      "2": 77816,
      "3": 94913,
      "4": 113435
    },
    OK: {
      "1": 55362,
      "2": 71043,
      "3": 82213,
      "4": 91528
    },
    OR: {
      "1": 70266,
      "2": 86269,
      "3": 103282,
      "4": 119432
    },
    PA: {
      "1": 66923,
      "2": 81574,
      "3": 103172,
      "4": 125861
    },
    PR: {
      "1": 27212,
      "2": 27212,
      "3": 32352,
      "4": 43538
    },
    RI: {
      "1": 72515,
      "2": 93429,
      "3": 119892,
      "4": 138933
    },
    SC: {
      "1": 59661,
      "2": 74874,
      "3": 87940,
      "4": 102244
    },
    SD: {
      "1": 63862,
      "2": 83730,
      "3": 97624,
      "4": 113008
    },
    TN: {
      "1": 59052,
      "2": 75424,
      "3": 88939,
      "4": 99689
    },
    TX: {
      "1": 61460,
      "2": 79870,
      "3": 89842,
      "4": 108866
    },
    UT: {
      "1": 78917,
      "2": 87303,
      "3": 106284,
      "4": 120187
    },
    VA: {
      "1": 75756,
      "2": 95482,
      "3": 116903,
      "4": 139667
    },
    VI: {
      "1": 40445,
      "2": 48609,
      "3": 51827,
      "4": 56782
    },
    VT: {
      "1": 65712,
      "2": 88215,
      "3": 111980,
      "4": 132356
    },
    WA: {
      "1": 86558,
      "2": 100800,
      "3": 118442,
      "4": 139828
    },
    WI: {
      "1": 66106,
      "2": 82346,
      "3": 101490,
      "4": 122571
    },
    WV: {
      "1": 57979,
      "2": 64478,
      "3": 83128,
      "4": 90164
    },
    WY: {
      "1": 61866,
      "2": 77243,
      "3": 93279,
      "4": 113060
    }
  };
  return medianMap[state][persons > 4 ? 4 : persons] + (persons > 4 ? (persons - 4) * 9900 : 0);
}

exports.default = getStateMedianFamilyIncome; // Scraping helper script
// const states = {
//   AL: 'Alabama',
//   AK: 'Alaska',
//   AS: 'American Samoa',
//   AZ: 'Arizona',
//   AR: 'Arkansas',
//   CA: 'California',
//   CO: 'Colorado',
//   CT: 'Connecticut',
//   DE: 'Delaware',
//   DC: 'District Of Columbia',
//   FM: 'Federated States Of Micronesia',
//   FL: 'Florida',
//   GA: 'Georgia',
//   GU: 'Guam',
//   HI: 'Hawaii',
//   ID: 'Idaho',
//   IL: 'Illinois',
//   IN: 'Indiana',
//   IA: 'Iowa',
//   KS: 'Kansas',
//   KY: 'Kentucky',
//   LA: 'Louisiana',
//   ME: 'Maine',
//   MH: 'Marshall Islands',
//   MD: 'Maryland',
//   MA: 'Massachusetts',
//   MI: 'Michigan',
//   MN: 'Minnesota',
//   MS: 'Mississippi',
//   MO: 'Missouri',
//   MT: 'Montana',
//   NE: 'Nebraska',
//   NV: 'Nevada',
//   NH: 'New Hampshire',
//   NJ: 'New Jersey',
//   NM: 'New Mexico',
//   NY: 'New York',
//   NC: 'North Carolina',
//   ND: 'North Dakota',
//   MP: 'Northern Mariana Islands',
//   OH: 'Ohio',
//   OK: 'Oklahoma',
//   OR: 'Oregon',
//   PW: 'Palau',
//   PA: 'Pennsylvania',
//   PR: 'Puerto Rico',
//   RI: 'Rhode Island',
//   SC: 'South Carolina',
//   SD: 'South Dakota',
//   TN: 'Tennessee',
//   TX: 'Texas',
//   UT: 'Utah',
//   VT: 'Vermont',
//   VI: 'Virgin Islands',
//   VA: 'Virginia',
//   WA: 'Washington',
//   WV: 'West Virginia',
//   WI: 'Wisconsin',
//   WY: 'Wyoming',
// };
// function innerTextToNumber(str) {
//   return Number((str || '').replace(/[\D|,]/, '').replace(',', ''));
// }
// const unsorted = Array.from(document.querySelectorAll('table thead tr'))
//     .slice(3)
//     .map(r => ({
//       state: Object.keys(states).find(stKey => states[stKey] === Object.values(states).find(st => st.toUpperCase() === (r.querySelector('td:nth-of-type(1)') || {}).innerText)),
//       1: innerTextToNumber((r.querySelector('td:nth-of-type(2)') || {}).innerText),
//       2: innerTextToNumber((r.querySelector('td:nth-of-type(3)') || {}).innerText),
//       3: innerTextToNumber((r.querySelector('td:nth-of-type(4)') || {}).innerText),
//       4: innerTextToNumber((r.querySelector('td:nth-of-type(5)') || {}).innerText),
//     }))
//     .filter(obj => (obj.state || '').length)
//     .reduce((accum, obj) => ({
//       [obj.state]: {
//         1: obj[1],
//         2: obj[2],
//         3: obj[3],
//         4: obj[4],
//       },
//       ...accum,
//     }), {});
// Object.keys(unsorted)
//   .sort()
//   .reduce((acc, key) => {
//     acc[key] = unsorted[key];
//     return acc;
//   }, {});